import React, { useContext } from 'react';
import Select, { components } from 'react-select';
import { ThemeContext } from 'styled-components';
import * as s from './styled-dropdown';

const getDefaultStyles = (colors) => ({
  option: (provided, state) => ({
    ...provided,
    padding: 5,
    backgroundColor: state.isSelected
      ? colors.blue
      : state.isFocused
      ? colors.lightgrey
      : colors.card,
    color: colors.label,
  }),
  control: (provided) => ({
    ...provided,
    minWidth: 140,
    margin: '0 10px',
    borderRadius: 16,
    minHeight: 36,
    backgroundColor: colors.card,
    borderColor: colors.disabled,
    boxShadow: 'none',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition, color: colors.label };
  },
  menu: (provided) => ({
    ...provided,
    zIndex: 1001,
    position: 'absolute',
    backgroundColor: colors.card,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: 13,
    color: colors.label,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorContainer: () => ({
    padding: 5,
  }),
});

const Dropdown = ({
  value,
  onChange,
  options,
  style,
  placeholder,
  image,
  disabled,
  isMulti,
  isSearchable = true,
  menuPlacement,
}) => {
  const { colors } = useContext(ThemeContext);
  const defaultStyles = getDefaultStyles(colors);

  if (image) {
    const ValueContainer = ({ children, ...props }) => (
      <components.ValueContainer {...props}>
        <s.Icon margin="0px" src={image} alt="" size="30px" />
      </components.ValueContainer>
    );

    return (
      <Select
        isMulti={isMulti}
        isSearchable={isSearchable}
        isDisabled={disabled}
        menuPlacement={menuPlacement}
        components={{ ValueContainer }}
        placeholder={placeholder}
        styles={{
          ...defaultStyles,
          control: (provided) => ({
            ...provided,
            minWidth: 0,
            margin: '0',
            borderRadius: 16,
            minHeight: 36,
            backgroundColor: colors.card,
            borderColor: colors.disabled,
            boxShadow: 'none',
          }),
        }}
        value={value}
        options={options}
        onChange={onChange}
      />
    );
  }

  return (
    <Select
      isMulti={isMulti}
      isSearchable={isSearchable}
      isDisabled={disabled}
      menuPlacement={menuPlacement}
      placeholder={placeholder}
      styles={style || defaultStyles}
      value={value}
      options={options}
      onChange={onChange}
    />
  );
};

export default Dropdown;
